export class Patients {
    static moduleName = 'patients';
    static moduleEntityName = 'patientsEntity';
    static listTitle = 'Справочник пациентов';
    static createTitle = 'Добавление нового пациента';
    static apiPrefix = '/patients';
}